import { logoutResource } from '@/services/auth.service'
import { useConfirmDialog } from '@/composables/useConfirm'

export default async function useLogout(question) {
  try {
    await useConfirmDialog({question})
    await logoutResource.execute({}, {})
    location.reload()
    // window.location.href = '/'
} catch (e) {
  window.location.href = '/'
  // return Promise.reject(e)
}
}